import { isEmpty } from "lodash";

const loggedErrors = {};

// different structure with ordering DynamicForm, reuse later once CreateNewCustomer modal is unified
export const getMergedStaticBlocks = (t, staticConfigData, uiBlocksData, formValues, clientType) => {
    if (!staticConfigData || staticConfigData.hidden) {
        return [];
    }

    // const uiConfiguredFields =
    //     typeof uiBlocksData === "function" ? uiBlocksData(t, formValues, clientType) : uiBlocksData;

    const uiConfiguredFields = uiBlocksData;

    if (!uiConfiguredFields || isEmpty(uiConfiguredFields)) {
        return [];
    }

    const mergedStaticBlocks = uiConfiguredFields
        .map(uiField => {
            const fieldName = uiField.key;
            const externalField = staticConfigData.attrs[fieldName] || {};
            // return null for empty field
            if (!uiField.withoutExternalConfig && (!externalField || isEmpty(externalField))) {
                const logKey = `${fieldName}_${staticConfigData.name}_${staticConfigData.description}`;
                if (!loggedErrors[logKey]) {
                    console.info(
                        `⚠️ No external static config found: ${fieldName} | ${staticConfigData.name} | ${staticConfigData.description}`
                    );
                    loggedErrors[`${fieldName}_${staticConfigData.name}_${staticConfigData.description}`] = true;
                }
                // console.warn(
                //     `%c ⚠️ UI cannot find match for static config\nFIELD: ${fieldName}\nBLOCK NAME: ${staticConfigData.name}\nBLOCK DESCRIPTION: ${staticConfigData.description}`
                // );
                // externalField.component = () => null;
                // return null;
            }
            return {
                ...uiField, // set default ui field values
                // ...externalField, // override default ui values with externally configured values
                order: externalField.order,
                disabled: externalField.disabled || uiField.disabled,
                isReq: "required" in externalField && !uiField.isHidden ? externalField.required : uiField.isReq,
                isHidden: externalField.hidden || externalField.hidden || uiField.isHidden,
                isHiddenByConfig: externalField.hidden || externalField.hidden,
                hiddenValues: externalField.hiddenValues,
                key: uiField.key, // name should match static field param => by that key value is being saved
                title: t(externalField.name) || t(uiField.title), // label to be displayed over the field input
            };
        })
        // filter hidden items
        .filter(item => !item.hidden)
        // sort by order param
        .sort((a, b) => {
            if (a.order && b.order) {
                return a.order - b.order;
            }
            return 1;
        });

    return mergedStaticBlocks;
};
